import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取全部一级分类信息 **/
    GET_CATES_PARENT(data) {
        controller='EsCate';
        action='GetParentCates';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取全部二级分类信息 **/
    GET_CATES_CHILD(data) {
        controller='EsCate';
        action='GetChildCates';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取全部分类信息 **/
    GET_CATES_ALL(data) {
        controller='EsCate';
        action='GetCatesAll';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取一级分类信息列表 **/
    GET_PARENT_LIST(data) {
        controller='EsCate';
        action='GetList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取二级分类信息列表 **/
    GET_CHILD_LIST(data) {
        controller='EsCate';
        action='GetChildList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增分类信息 **/
    ADD_CATES(data) {
        controller='EsCate';
        action='AddCate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 编辑分类信息 **/
    EDIT_CATES(data) {
        controller='EsCate';
        action='EditCate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除分类信息 **/
    DEL_CATES(data) {
        controller='EsCate';
        action='DelCate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取分类信息 **/
    CATES_INFO(data) {
        controller='EsCate';
        action='GetCateInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 修改分类是否显示 **/
    CHANGE_CATES_ISSHOW(data) {
        controller='EsCate';
        action='ChangeCateIsshow';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 修改分类排序 **/
    CHANGE_CATES_SORT(data) {
        controller='EsCate';
        action='ChangeCateSort';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

   
}